import { useState ,useRef } from "react";
import { colorClasses } from "../../utils";
import Feedback from "../Feedback";
import ActionButtons from "../ActionButtons";
import correct from "../../assets/sounds/correct.wav"
import wrong from "../../assets/sounds/wrong.wav"
import retry from "../../assets/sounds/retry.wav"
import check from "../../assets/sounds/check.wav"
const SelectOptionExercise = ({ exercise }) => {
  const [state, setState] = useState(null);
  const [feedback, setFeedback] = useState(null);
  const correctSound = useRef(new Audio(correct))
  const wrongSound = useRef(new Audio(wrong))
  const retrySound = useRef(new Audio(retry))
  const checkSound = useRef(new Audio(check))
  const handleSelectOption = (option) => {
    checkSound.current.currentTime = 0;
    checkSound.current.play();
    setState(option);
    setFeedback(null);
  };

  const handleCheck = () => {
   
    if (state === null) {
      setFeedback({ type: 'error', message: '⚠️ من فضلك اختر إجابة أولاً!' });
      return;
    }
    const isCorrect = state === exercise.correctAnswer;
     if(isCorrect){
        correctSound.current.currentTime = 0;
        correctSound.current.play()
    }else{
        wrongSound.current.currentTime = 0;
        wrongSound.current.play()
    }
    setFeedback({
      type: isCorrect ? 'success' : 'error',
      message: isCorrect ? exercise.successMessage : exercise.errorMessage
    });
  };

  const handleReset = () => {
    retrySound.current.currentTime = 0;
    retrySound.current.play()
    setState(null);
    setFeedback(null);
  };

  return (
    <div className="w-full max-w-4xl mx-auto px-2 sm:px-4">

      {/* ================= Pattern Area (Fixed Overflow) ================= */}
      <div
        className="flex flex-wrap gap-3 sm:gap-4 my-4 sm:my-6 justify-center p-4 sm:p-6 rounded-2xl"
        style={{ backgroundColor: exercise.backgroundColor || "#f3f4f6" }}
      >
        {exercise.pattern.map((item, idx) => (
          <div
            key={idx}
            className="flex-grow basis-[90px] sm:basis-[110px] 
                      h-12 sm:h-16 flex items-center justify-center 
                      text-2xl sm:text-4xl rounded-xl border-3 
                      border-gray-300 bg-white shadow-sm"
          >
            {item.type === "missing"
              ? (state || item.placeholder)
              : item.emoji}
          </div>
        ))}
      </div>

      {/* ================= Options ================= */}
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 my-4 sm:my-6 justify-center items-stretch border-3 border-gray-200 p-4 sm:p-6 rounded-2xl bg-white shadow-sm">
        {exercise.options.map((option, idx) => (
          <div
            key={idx}
            onClick={() => handleSelectOption(option)}
            className={`w-full sm:w-auto sm:min-w-[120px] px-5 sm:px-6 py-3 sm:py-4
              flex items-center justify-center text-lg sm:text-xl font-medium
              border-3 rounded-xl cursor-pointer transition-all
              hover:scale-105 active:scale-95 ${
                state === option
                  ? "border-teal-500 bg-teal-50 shadow-md"
                  : "border-gray-400 bg-white shadow-sm hover:border-gray-500"
              }`}
            style={{ lineHeight: "1.2" }}
          >
            {option}
          </div>
        ))}
      </div>

      <ActionButtons onCheck={handleCheck} onReset={handleReset} />
      <Feedback feedback={feedback} />
    </div>
  );
};

export default SelectOptionExercise;
